import { getIsNav4UserOptOut } from '@atlassian/jira-navigation-apps-sidebar-nav4-get-user-meta/src/index.tsx';
import type { BetaCohort, Nav4RolloutBeta } from '../../../types.tsx';

export const getNav4RolloutForBetaCohort = (cohort: BetaCohort) => (): Nav4RolloutBeta =>
	cohort !== 'existing-customers'
		? { stage: 'beta', cohort }
		: { stage: 'beta', cohort, isUserOptOut: getIsNav4UserOptOut() };
